import { fetchAllSport, fetchAllTypes  } from '../../api/homes';


const actions = {

  async fetchAllSport({ commit }) {
    try {
      const response = await fetchAllSport();
      return response.data.html;
    } catch (error) {
      console.error('An error occurred while fetching all sport categories and sports:', error);
      commit('SET_MESSAGE', 'Failed to fetch sport categories and sports');
      return {};
    }
  },
  async fetchAllTypes({ commit }) {
    try {
      const response = await fetchAllTypes();
      return response.data.html;
    } catch (error) {
      console.error('An error occurred while fetching all offer types:', error);
      commit('SET_MESSAGE', 'Failed to fetch offer types');
      return [];
    }
  }
};

export default {
    actions
  };
